import { render, staticRenderFns } from "./TablaCatequistasSimple.vue?vue&type=template&id=7ed00ec4&scoped=true&"
import script from "./TablaCatequistasSimple.vue?vue&type=script&lang=js&"
export * from "./TablaCatequistasSimple.vue?vue&type=script&lang=js&"
import style0 from "./TablaCatequistasSimple.vue?vue&type=style&index=0&id=7ed00ec4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed00ec4",
  null
  
)

export default component.exports